export function MaxLength(upperBound: number): PropertyDecorator {
  return () => {
    const key = Symbol();

    return {
      get(): string {
        return this[key];
      },
      set(newValue: string) {
        // @ts-expect-error we're setting data into a new unique symbol
        // to avoid naming conflicts with existing properties on the object
        this[key] = String(newValue || '').slice(0, upperBound);
      },
      configurable: true,
      enumerable: true,
    };
  };
}
